import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeft } from 'lucide-react';
import clsx from 'clsx';
import { useTheme } from '../context/ThemeContext';

const BackButton = ({ onBack, className, children, iconSize = 16, ...props }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const backButtonClassName = clsx(
    'flex items-center my-3 gap-2 text-xl transition-colors',
    {
      'text-slate-300 hover:text-white': isDark,
      'text-slate-600 hover:text-slate-900': !isDark
    },
    className
  );

  return (
    <button 
      onClick={onBack}
      className={backButtonClassName}
      {...props}
    >
      <ArrowLeft size={iconSize} />
      {children || 'Back'}
    </button>
  );
};

BackButton.propTypes = {
  onBack: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  iconSize: PropTypes.number,
};

export default BackButton;